import { Flex } from "@redotech/redo-web/flex";
import classNames from "classnames";
import { memo } from "react";
import { MacroTagPicker } from "../../v2/setting/macros/macro-tag-picker";
import * as css from "./rule-tag-picker.module.css";

// Tag picker for rule actions/conditions. Reads from CockroachDB via the Effect
// API; tag creation is disabled here — tags are managed in Settings > Support > Tags.
export const RuleTagPicker = memo(function RuleTagPicker({
  selectedTagNames,
  onChange,
  disabled = false,
}: {
  selectedTagNames: string[];
  onChange: (names: string[]) => void;
  disabled?: boolean;
  addButtonLabel?: string;
}) {
  return (
    <Flex className={classNames(disabled && css.disabled)}>
      <MacroTagPicker onChange={onChange} selectedTagNames={selectedTagNames} />
    </Flex>
  );
});
